const downloadFile = (fileName: string, fileContents: string): void => {
  // Hack to force download of file
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  const blob = new Blob([fileContents], { type: "octet/stream" });
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export function downloadFileFromUrl(filename: string, url: string) {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename || "";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export default downloadFile;
